import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo-gray",
  "use": "icon-logo-gray-usage",
  "viewBox": "0 0 170 170",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 170 170\" id=\"icon-logo-gray\"><g fill=\"#EDEDED\" fill-rule=\"evenodd\"><path d=\"M0 20.4V170h149.6V69.972h-23.875v76.153H23.872V44.275h76.156V20.4zM115.6 0v24.642h29.766V54.4H170V0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol